import {
  ExclamationCircleOutlined,
  ExportOutlined,
  FileTextOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import { Button, Space } from "antd";
import moment from "moment";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

import { ReceivePaymentButton } from "features/card-bait";
import { generatePath, useNavigate } from "react-router-dom";
import { getGlobalCurrency } from "shared/lib/utils";
import ROUTES from "shared/routes";
import { IconCheckControl } from "shared/ui/icon-check-control";
import { ActData } from "../types";
import styles from "./index.module.scss";
import {
  ShowInfoOrganizationModal,
  ShowInfoOrganizationModalType,
} from "./show-info-organization-modal";
import { SignActModal, SignActType } from "./sign-act-modal";

export const ActsItem = ({ act }: { act: ActData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const signActModalRef = useRef<SignActType>(null);
  const showInfoOrganizationModalRef =
    useRef<ShowInfoOrganizationModalType>(null);

  return (
    <div className={styles.listItem}>
      <SignActModal ref={signActModalRef} />
      <ShowInfoOrganizationModal ref={showInfoOrganizationModalRef} />
      <div className={styles.head}>
        <div className={styles.iconWrapper}>
          <FileTextOutlined />
        </div>
        <div style={{ marginRight: "auto" }}>
          {t("acts.act_number")} {act?.document_number}
          <div className={styles.date}>
            {t("acts.act_date")}: <br />{" "}
            {moment(act?.contract_date).format("DD.MM.YYYY")}
          </div>
        </div>
        <div className={styles.price}>{getGlobalCurrency(act?.total)}</div>
      </div>
      <div>
        <div className={styles.organization}>
          <ProfileOutlined />
          {act?.company?.name}
          <ExclamationCircleOutlined
            style={{ marginLeft: "auto", cursor: "pointer" }}
            onClick={() =>
              showInfoOrganizationModalRef.current?.open(act?.company)
            }
          />
        </div>
        <Space vertical>
          <div className={styles.infoItem}>
            <IconCheckControl
              checked={act?.edo_status?.type === "SUCCESS"}
              loading={act?.edo_status?.type === "LOADING"}
            />
            {act?.edo_status?.label}
            {act?.sign_provider === "DTT" && (
              <Button
                type="link"
                iconPlacement="end"
                onClick={() =>
                  signActModalRef.current?.open(act?.document_number)
                }
                style={{ padding: 0 }}
              >
                {t("acts.how_to_sign")}
              </Button>
            )}
          </div>
          <div className={styles.infoItem}>
            <IconCheckControl checked={act?.payment_status?.code === "PAYED"} />
            {act?.payment_status?.label}
          </div>

          <div className={styles.infoItem}>
            {act?.receipt_url && (
              <>
                <IconCheckControl checked />
                <Button
                  type="link"
                  iconPlacement="end"
                  icon={<ExportOutlined />}
                  onClick={() => window.open(act?.receipt_url)}
                  style={{ padding: 0 }}
                >
                  {t("acts.view_receipt")}
                </Button>
              </>
            )}
          </div>
          <div className={styles.infoItem}>
            {(act?.sign_provider === "SMS" ||
              act?.sign_provider === "SMART_BRIDGE") && (
              <Button
                type="primary"
                onClick={() =>
                  navigate(
                    generatePath(ROUTES.SING_ACT_ID, {
                      actId: act.id,
                    }),
                  )
                }
              >
                {act.edo_status?.code === "FINISHED"
                  ? t("acts.view")
                  : t("acts.view_and_sign")}
              </Button>
            )}
            {act?.can_payout && <ReceivePaymentButton actId={act?.id} />}
          </div>
        </Space>
      </div>
    </div>
  );
};
